import loadable from '@loadable/component';

/* istanbul ignore next */
export const SuburbanBlackFridayBannerContainerLoadable = loadable(
  () => import('./container').catch(() => ({ SuburbanBlackFridayBannerContainer: () => null })),
  {
    resolveComponent: ({ SuburbanBlackFridayBannerContainer }) => SuburbanBlackFridayBannerContainer,
  },
);
